import { X } from 'lucide-react';
import Sheet from './Sheet';
import ProductImage from './ProductImage';
import { boxLabel, isMultiBox } from '../lib/boxes';
import { cn, qty } from '../lib/utils';

/* A carton whose EAN belongs to several products (a shared component, the
   same base box on two items): no rule can tell which one is on the floor,
   so the operator says. The line chosen last time for this code comes first. */
export default function ChooseLineSheet({ code, choices, lastLineId = null, showPo = false, onPick, onClose }) {
  const ordered = [...choices].sort((a, b) => Number(b.line.id === lastLineId) - Number(a.line.id === lastLineId));
  return (
    <Sheet open onClose={onClose} label="Which product is this?">
      <div className="px-4 pb-4 pt-3">
        <div className="flex items-start justify-between gap-3">
          <div>
            <p className="font-cond text-[24px] font-bold leading-none">Which product is this?</p>
            <p className="mt-1 text-[14px] text-ink2">
              <span className="font-mono tabular-nums">{code}</span> is on {choices.length} products of this delivery. Tap the one you are holding.
            </p>
          </div>
          <button type="button" onClick={onClose} aria-label="Close" className="-mr-2 -mt-1 flex h-10 w-10 items-center justify-center rounded-full active:bg-sunken">
            <X className="h-5 w-5" />
          </button>
        </div>
        <ul className="mt-3 space-y-1.5">
          {ordered.map((c) => {
            const boxIndex = isMultiBox(c.line) && c.entry.box_id ? c.line.boxes.findIndex((b) => b.id === c.entry.box_id) : -1;
            return (
              <li key={c.line.id}>
                <button type="button" onClick={() => onPick(c)} className="flex w-full items-center gap-3 rounded-xl bg-sunken px-3 py-2.5 text-left active:bg-line">
                  <ProductImage src={c.line.image} alt="" className="h-14 w-14" />
                  <span className="min-w-0 flex-1">
                    <span className="clamp-2 block text-[14px] font-semibold leading-tight">{c.line.name}</span>
                    <span className="mt-0.5 block text-[12px] text-ink2">
                      {c.line.vendor_code && <span className="font-mono">{c.line.vendor_code}</span>}
                      {boxIndex >= 0 && ` · ${boxLabel(c.line.boxes[boxIndex], boxIndex)}`}
                      {showPo && c.line.po && ` · ${c.line.po.name}`}
                      {c.others > 0 && ` · also on ${c.others} other ${c.others === 1 ? 'order' : 'orders'}`}
                      {c.line.id === lastLineId && ' · chosen last time'}
                    </span>
                  </span>
                  <span className={cn('font-cond shrink-0 text-[22px] font-bold leading-none', !c.room && 'text-alert')}>
                    {qty(c.scanned)}
                    <span className="text-[14px] font-semibold text-ink2"> / {qty(c.line.to_receive)}</span>
                  </span>
                </button>
              </li>
            );
          })}
        </ul>
        <p className="mt-3 text-[13px] text-ink2">None of these? Close, and the scan is not counted.</p>
      </div>
    </Sheet>
  );
}
